import { get } from 'helpers/api_helper';
import { NumberToWordsConverter, customFormatDate, teethsTable } from 'helpers/basic_helper';
import React, { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import MetaTags from "react-meta-tags";
import { companyName } from "helpers/company_name";

const loadingStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
};

const OrderformPdfPrint = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const [printdata, setPrintdata] = React.useState(null);

    const safeTeeth = (rawTeeth) => {
        try {
            if (!rawTeeth) return [];
            return Array.isArray(rawTeeth) ? rawTeeth : JSON.parse(rawTeeth);
        } catch (e) {
            return [];
        }
    };

    useEffect(() => {
        const fetchOrderform = async () => {
            try {
                const data = await get(`api/orderform/print/${urlParams.get('_orderform')}`);
                setPrintdata(data?.response);
            } catch (e) {
                console.error("Fetch orderform error:", e);
            }
        };
        fetchOrderform();
    }, []);

    if (printdata && printdata?.orderform && String(printdata?.orderform?.orderform_number).trim() !== String(urlParams.get('_orderform')).trim()) {
        console.warn("Orderform number mismatch:", printdata?.orderform?.orderform_number, urlParams.get('_orderform'));
    }

    const printPage = () => {
        window.print();
    };

    useEffect(() => {
        const handleAfterPrint = () => {
            window.close();
        };
        window.addEventListener('afterprint', handleAfterPrint);
        return () => {
            window.removeEventListener('afterprint', handleAfterPrint);
        };
    }, []);

    return (
        <React.Fragment>
            <MetaTags> <title>Orderform | Oralstop</title> </MetaTags>
            <style>{`
                @page {
                    size: A4 portrait;
                    margin: 6mm 8mm;
                }
                @media print {
                    html, body {
                        margin: 0 !important;
                        padding: 0 !important;
                        background: #fff !important;
                        width: 100% !important;
                    }
                    .no-print {
                        display: none !important;
                    }
                    .print-container {
                        width: 100% !important;
                        max-width: 100% !important;
                        padding: 0 !important;
                        margin: 0 auto !important;
                        min-height: auto !important;
                    }
                    .table-responsive {
                        overflow: visible !important;
                    }
                }
                .orderform-container {
                    box-sizing: border-box;
                    width: 100%;
                    max-width: 794px;
                    margin: 0 auto;
                    padding: 10px 14px;
                    background: #fff;
                    color: #000;
                    font-size: 11px;
                }
                .orderform-table {
                    width: 100% !important;
                    table-layout: fixed !important;
                    border-collapse: collapse !important;
                    font-size: 11px !important;
                    margin-bottom: 0 !important;
                }
                .orderform-table th, .orderform-table td {
                    padding: 4px 3px !important;
                    vertical-align: middle !important;
                    border: 1px solid #1a1a1a !important;
                    word-break: break-word !important;
                    overflow-wrap: break-word !important;
                }
                .orderform-table thead th {
                    background-color: #f8f9fa !important;
                    font-weight: 600 !important;
                    -webkit-print-color-adjust: exact !important;
                    print-color-adjust: exact !important;
                }
            `}</style>
            <div>
                {
                    printdata !== null ?
                        <>
                            <div className="no-print" style={{ width: '100%', textAlign: 'center', padding: '16px 0' }}>
                                <button
                                    onClick={() => printPage()}
                                    className='btn btn-primary'
                                    type="button"
                                    style={{ width: '130px', height: '48px', fontSize: '15px' }}
                                >
                                    <i className='fas fa-print me-2'></i>Print
                                </button>
                            </div>
                            <div id="printablediv">
                                <div className="print-container orderform-container">
                                    {/* Company Header */}
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                        <div className="d-flex align-items-start" style={{ maxWidth: '65%' }}>
                                            <img
                                                src="https://apiv2.dgddl.in/uploads/241002/241002_print.png"
                                                alt="Logo"
                                                style={{ width: '85px', marginRight: '14px', flexShrink: 0 }}
                                            />
                                            <div>
                                                <div style={{ fontWeight: 'bold', fontSize: '12.5px', lineHeight: '1.2' }}>
                                                    {companyName(
                                                        printdata?.org?.title,
                                                        printdata?.orderform?.orderform_date
                                                    )?.toUpperCase()}
                                                </div>
                                                <address style={{ fontSize: '11px', lineHeight: '1.3', marginBottom: 0, marginTop: '3px' }}>
                                                    {printdata?.org?.address}
                                                </address>
                                            </div>
                                        </div>
                                        <div className="text-end" style={{ fontSize: '11px', lineHeight: '1.4' }}>
                                            <span>phone: {printdata?.org?.mobile}</span><br />
                                            <span>Email: {printdata?.org?.email}</span><br />
                                            <span>Web: {printdata?.org?.website ? printdata.org.website.replace('https://', 'www.') : ''}</span>
                                        </div>
                                    </div>

                                    {/* Document Title */}
                                    <div className="text-center my-2">
                                        <h3 style={{ margin: 0, fontWeight: 'bold', letterSpacing: '1px', fontSize: '18px' }}>ORDERFORM</h3>
                                    </div>

                                    {/* Client and Orderform Details */}
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        <div style={{ maxWidth: '60%' }}>
                                            <div style={{ fontWeight: 'bold', fontSize: '12px' }}>Dr. {printdata?.client?.clientname}</div>
                                            <address style={{ fontSize: '11px', lineHeight: '1.3', marginBottom: 0, marginTop: '2px' }}>
                                                {printdata?.client?.address}
                                            </address>
                                            <div style={{ fontSize: '11px', marginTop: '2px' }}>
                                                phone: <b>{printdata?.client?.phone}</b>
                                            </div>
                                        </div>
                                        <div className="text-end" style={{ fontSize: '11px', lineHeight: '1.4' }}>
                                            <div>Doc #: <b>{printdata?.orderform?.orderform_number}</b></div>
                                            <div>Date: <b>{customFormatDate(printdata?.orderform?.orderform_date, "DD/MM/YYYY")}</b></div>
                                        </div>
                                    </div>

                                    {/* Table */}
                                    <div className="table-responsive" style={{ overflow: 'visible' }}>
                                        <table className="table table-bordered orderform-table">
                                            <colgroup>
                                                <col style={{ width: '4%' }} />
                                                <col style={{ width: '13%' }} />
                                                <col style={{ width: '11%' }} />
                                                <col style={{ width: '18%' }} />
                                                <col style={{ width: '16%' }} />
                                                <col style={{ width: '16%' }} />
                                                <col style={{ width: '5%' }} />
                                                <col style={{ width: '8%' }} />
                                                <col style={{ width: '9%' }} />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th className="text-center">#</th>
                                                    <th>Order #</th>
                                                    <th>Order Date</th>
                                                    <th>Patient</th>
                                                    <th>Product</th>
                                                    <th className="text-center">Teeth #</th>
                                                    <th className="text-end">units</th>
                                                    <th className="text-end">Rate/Item</th>
                                                    <th className="text-end">Total Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    (printdata?.order || []).map((v, i) => {
                                                        const productList = Array.isArray(v?.products) ? v.products : [];
                                                        return productList.map((pro, pkey) => {
                                                            const itemTotal = (parseFloat(pro?.unit_price || 0) * parseFloat(pro?.unit || 0)).toFixed(2);
                                                            if (v.doctor) {
                                                                return (
                                                                    <React.Fragment key={`PK_${i}_${pkey}`}>
                                                                        <tr>
                                                                            <td style={{ padding: '4px 3px' }}></td>
                                                                            <td colSpan={8} style={{ padding: '4px 3px' }}>
                                                                                <strong>Requested by {v.doctor}</strong>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="text-center">{i + 1}</td>
                                                                            <td>{pro?.order_id}</td>
                                                                            <td>{customFormatDate(v?.order_date, 'DD MMM ,YY')}</td>
                                                                            <td>{v?.patient_name}</td>
                                                                            <td>{pro?.product_id}</td>
                                                                            <td style={{ padding: '0 !important' }}>{teethsTable(safeTeeth(pro?.teeth))}</td>
                                                                            <td className="text-end">{pro?.unit}</td>
                                                                            <td className="text-end">{pro?.unit_price}</td>
                                                                            <td className="text-end">{itemTotal}</td>
                                                                        </tr>
                                                                    </React.Fragment>
                                                                );
                                                            }

                                                            return (
                                                                <tr key={`PK_${i}_${pkey}`}>
                                                                    <td className="text-center">{i + 1}</td>
                                                                    <td>{pro?.order_id}</td>
                                                                    <td>{customFormatDate(v?.order_date, 'DD MMM ,YY')}</td>
                                                                    <td>{v?.patient_name}</td>
                                                                    <td>{pro?.product_id}</td>
                                                                    <td style={{ padding: '0 !important' }}>{teethsTable(safeTeeth(pro?.teeth))}</td>
                                                                    <td className="text-end">{pro?.unit}</td>
                                                                    <td className="text-end">{pro?.unit_price}</td>
                                                                    <td className="text-end">{itemTotal}</td>
                                                                </tr>
                                                            );
                                                        });
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Total */}
                                    <div className="d-flex justify-content-between align-items-center pt-3 pb-2" style={{ fontSize: '11.5px' }}>
                                        <div><strong>INR <NumberToWordsConverter number={printdata?.orderTotal} /></strong></div>
                                        <div className="text-end">
                                            <b style={{ marginRight: '8px' }}>Total:</b>
                                            <b>{parseFloat(printdata?.orderTotal || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                        </div>
                                    </div>

                                    {/* Signatures */}
                                    <div className="d-flex justify-content-between align-items-end pt-5" style={{ fontSize: '11px' }}>
                                        <div>Delivery By <br />Delivery Boy</div>
                                        <div className="text-center">Received By</div>
                                        <div className="text-end">Authorised Signatory</div>
                                    </div>
                                </div>
                            </div>
                        </> :
                        <div style={loadingStyle}>
                            <img src="https://apiv2.dgddl.in/uploads/241002/241002_print.png" alt="Loading" style={{ width: '92px', marginRight: '16px', float: 'left' }} /><br /><br /><br /><br />
                            <span>Loading Data...</span>
                        </div>
                }
            </div>
        </React.Fragment>
    );
};

export default OrderformPdfPrint;
